module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "prect"
  }, [_c('a', {
    attrs: {
      "id": "pIII"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "pIII"
    }
  }), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "id": "pIII"
    }
  }), _c('a', {
    attrs: {
      "href": "#/007List_of_Maps"
    }
  }, [_vm._v("List of Maps")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/008Acknowledgements"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/0091_The_Context"
    }
  }, [_vm._v("1. The Context")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/0102_x2018Absolutely_Astonishingx2019_The_War_Committee_and_the_Military"
    }
  }, [_vm._v("2. ‘Absolutely Astonishing’: The War Committee and the Military")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/0113_Decisionmaking_Januaryx2013February"
    }
  }, [_vm._v("3. Decision-making, January–February")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/0124_Decisionmaking_Marchx2013June"
    }
  }, [_vm._v("4. Decision-making, March–June")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/0135_x2018Grasping_at_the_Shadowx2019_Planning_for_the_Somme_Februaryx2013June"
    }
  }, [_vm._v("5. ‘Grasping at the Shadow’: Planning for the Somme, February–June")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/0146_x2018Favourable_Results_Are_Not_Anticipatedx2019_Preparations_for_Battle_June"
    }
  }, [_vm._v("6. ‘Favourable Results Are Not Anticipated’: Preparations for Battle, June")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/0157_x2018A_Short_Lifex2019_VII_and_VIII_Corps_on_1_July"
    }
  }, [_vm._v("7. ‘A Short Life’: VII and VIII Corps on 1 July")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/0168_x2018The_Enemyx0027s_Fire_Was_So_Intensex2019_X_Corps_on_1_July"
    }
  }, [_vm._v("8. ‘The Enemy's Fire Was So Intense’: X Corps on 1 July")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/0179_x2018Wave_after_Wave_Were_Mown_Downx2019_III_Corps_on_1_July"
    }
  }, [_vm._v("9. ‘Wave after Wave Were Mown Down’: III Corps on 1 July")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/01810_x2018Cowering_Men_in_Field_Greyx2019_XV_and_XIII_Corps_on_1_July"
    }
  }, [_vm._v("10. ‘Cowering Men in Field Grey’: XV and XIII Corps on 1 July")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/01911_Reflections_on_1_July"
    }
  }, [_vm._v("11. Reflections on 1 July")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/02012_x2018IllConsidered_Attacks_on_a_Small_Frontx2019_2x201313_July"
    }
  }, [_vm._v("12. ‘Ill-Considered Attacks on a Small Front’, 2–13 July")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/02113_x2018Cavalry_Sharpening_Their_Swordsx2019_14_July"
    }
  }, [_vm._v("13. ‘Cavalry Sharpening Their Swords’, 14 July")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/02214_x2018We_Are_a_Bit_Stuckx2019_15x201331_July"
    }
  }, [_vm._v("14. ‘We Are a Bit Stuck’, 15–31 July")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/02315_x2018Something_Wanting_in_the_Methods_Employedx2019_1_Augustx201312_September"
    }
  }, [_vm._v("15. ‘Something Wanting in the Methods Employed’, 1 August–12 September")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/02416_x2018A_Hell_of_a_Timex2019_Pozix00E8res_and_Mouquet_Farm_Julyx2013August"
    }
  }, [_vm._v("16. ‘A Hell of a Time’: Pozières and Mouquet Farm, July–August")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/02517_Summary_15_Julyx201312_September"
    }
  }, [_vm._v("17. Summary, 15 July–12 September")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "id": "pIV"
    }
  }), _c('a', {
    attrs: {
      "href": "#/02618_The_Politicians_and_the_Somme_Campaign_Julyx2013August"
    }
  }, [_vm._v("18. The Politicians and the Somme Campaign, July–August")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/02719_One_Divisionx0027s_Somme_The_First_Division_Julyx2013September"
    }
  }, [_vm._v("19. One Division's Somme: The First Division, July–September")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/02820_x2018An_Operation_Planned_on_Bolder_Linesx2019_Tanks_and_the_15_September_Plan"
    }
  }, [_vm._v("20. ‘An Operation Planned on Bolder Lines’: Tanks and the 15 September Plan")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/02921_Lumbering_Tanks_The_Battle_of_15_September"
    }
  }, [_vm._v("21. Lumbering Tanks: The Battle of 15 September")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/03022_25_September"
    }
  }, [_vm._v("22. 25 September")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/03123_x2018The_Tragic_Hill_of_Thiepvalx2019_26x201330_September"
    }
  }, [_vm._v("23. ‘The Tragic Hill of Thiepval’, 26–30 September")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/03224_x2018A_Severe_Trial_of_Body_and_Spiritx2019_The_Somme_October"
    }
  }, [_vm._v("24. ‘A Severe Trial of Body and Spirit’: The Somme, October")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/03325_x2018We_Must_Keep_Goingx2019_The_Politicians_and_the_Somme_Campaign_Septemberx2013October"
    }
  }, [_vm._v("25. ‘We Must Keep Going!’: The Politicians and the Somme Campaign, September–October")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/03426_The_Political_Battle_Beaumont_Hamel_13x201319_November"
    }
  }, [_vm._v("26. The Political Battle: Beaumont Hamel, 13–19 November")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/03527_Reflections_on_the_British_at_the_Somme"
    }
  }, [_vm._v("27. Reflections on the British at the Somme")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/03628_Epilogue_The_End_of_It_All_November_1916"
    }
  }, [_vm._v("28. Epilogue: The End of It All, November 1916")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/037Notes"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/038Bibliography"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/039Index"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-492049a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005-Contents.vue
// module id = 66
// module chunks = 0